module.exports = __webpack_public_path__ + "static/media/management-courses-new.73d59269.jpg";